import {
	UPDATE_CHATBOX_HEIGHT,
	SET_SELECTED_CONVERSATIONS,
	SET_TRANSCRIPT_VIEW,
	SET_SHOW_CONVERSATION_DETAILS,
} from '../actions/types';
import { readShowConversationDetails } from '../utils/conversationDetailsPreference';

const DEFAULT_INTERFACE_STYLES = {
	chatboxHeight: 89,
	runner: {
		openPipelineSheet: false,
		openPipelineSheetId: null,
		workflowType: null,
	},
	webchat: {
		selectedConversations: [],
		transcriptView: null,
		showConversationDetails: readShowConversationDetails(true),
	},
};

export default function userInterfaceReducer(
	state = DEFAULT_INTERFACE_STYLES,
	action
) {
	switch (action.type) {
		case UPDATE_CHATBOX_HEIGHT:
			return { ...state, chatboxHeight: action.payload };
		case 'TOGGLE_PIPELINE_SHEET':
			return {
				...state,
				runner: {
					...state.runner,
					openPipelineSheet: action.payload.openPipelineSheet,
					pipelineSheetProjectId: action.payload._project || null,
					workflowType: action.payload.workflowType || null,
				},
			};
		case SET_SELECTED_CONVERSATIONS:
			return {
				...state,
				webchat: {
					...state.webchat,
					selectedConversations: action.payload,
				},
			};
		case SET_TRANSCRIPT_VIEW:
			return {
				...state,
				webchat: {
					...state.webchat,
					transcriptView: action.payload,
					// Automatically open conversation details when setting transcript view
					...(action.payload && { showConversationDetails: true }),
				},
			};
		case SET_SHOW_CONVERSATION_DETAILS:
			return {
				...state,
				webchat: {
					...state.webchat,
					showConversationDetails: action.payload,
				},
			};
		default:
			return state;
	}
}
